export enum SpotlightVariant {
  SPOTLIGHT = 'spotlight',
  SPOTLIGHT_CARD = 'spotlight-card'
}
